import { IMessageEvent } from 'websocket';
import * as Env from 'widget/env';

import useHandleAddReaction from './use-handle-add-reaction/use-handle-add-reaction';
import useHandleAuthorizeError from './use-handle-authorize-error/use-handle-authorize-error';
import useHandleDeletedMessage from './use-handle-deleted-message/use-handle-deleted-message';
import useHandleMessage from './use-handle-message/use-handle-message';
import useHandleRemoveReaction from './use-handle-remove-reaction/use-handle-remove-reaction';
import useHandleTyping from './use-handle-typing/use-handle-typing';

type Event =
  | 'add_reaction'
  | 'authorize_error'
  | 'deleted_message'
  | 'message'
  | 'remove_reaction'
  | 'typing';

interface Data {
  event: Event;
  message?: Env.Message;
}

interface UseHandleEventParams {
  setAccessToken: Env.SetState<string | null | undefined>;
  setIsTyping: Env.SetState<boolean>;
  setMessageList: Env.SetState<Env.Message[]>;
}

const useHandleEvent = ({
  setAccessToken,
  setIsTyping,
  setMessageList,
}: UseHandleEventParams) => {
  const handleAddReaction = useHandleAddReaction(setMessageList);
  const handleAuthorizeError = useHandleAuthorizeError(setAccessToken);
  const handleDeletedMessage = useHandleDeletedMessage(setMessageList);
  const handleMessage = useHandleMessage(setMessageList);
  const handleRemoveReaction = useHandleRemoveReaction(setMessageList);
  const handleTyping = useHandleTyping(setIsTyping);

  const handleEvent = (messageEvent: IMessageEvent, accessToken: string) => {
    if (typeof messageEvent.data != 'string') return;
    const data: Data = JSON.parse(messageEvent.data);

    if (data.event == 'add_reaction' && data.message)
      handleAddReaction(data.message);
    else if (data.event == 'authorize_error') handleAuthorizeError();
    else if (data.event == 'deleted_message')
      handleDeletedMessage(data.message);
    else if (data.event == 'message' && data.message)
      handleMessage(data.message, accessToken);
    else if (data.event == 'remove_reaction')
      data.message && handleRemoveReaction(data.message);
    else if (data.event == 'typing') handleTyping(data.message, accessToken);
  };

  return handleEvent;
};

export default useHandleEvent;
